import { NgModule } from '@angular/core';
import { AutoAnswersComponent } from './auto-answers.component';
import { AutoAnswersService } from './auto-answers.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild()
  ],
  declarations: [
    AutoAnswersComponent
  ],
  providers: [
    AutoAnswersService
  ],
  exports: [
    AutoAnswersComponent
  ]
})

export class AutoAnswersModule {}
